import { render, staticRenderFns } from "./WorkIconOptions.vue?vue&type=template&id=508e004b"
import script from "./WorkIconOptions.vue?vue&type=script&lang=js"
export * from "./WorkIconOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports